module.exports = __webpack_public_path__ + "static/landingMobile-09941ad9b383b76e379bf2472538414a.png";